
import { initializeApp } from "firebase/app";

import { getAuth } from "firebase/auth";
import {getFirestore} from 'firebase/firestore';



// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDUCAhzXELXaP0Dz3j-gYe6QFpBV2d9Q0s",
  authDomain: "chat-first-6e809.firebaseapp.com",
  projectId: "chat-first-6e809",
  storageBucket: "chat-first-6e809.appspot.com",
  messagingSenderId: "125831414944",
  appId: "125831414944:web:89bf93f1bfbc7e87d935c5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app)
export const db = getFirestore(app)